module.exports = __webpack_public_path__ + "static/media/bar.539e79d2.svg";